import React from 'react';
import { db } from './Firebase';

const UpdateCover = () => {

    function updateCover(e) {
        e.preventDefault();
        
        const cover = document.getElementById('coverID');
        const form = new FormData();
        form.append('image', cover.files[0]);

        // uploading to imgbb
        fetch('https://api.imgbb.com/1/upload?key=5159c527ffc84ce94be36652b3fa0c9f', 
        { method: 'POST', body: form })
        .then(res => res.json())
        .then(image => {

            // updating document
            db.collection('cover').doc('6FqIhlrbKJEBKWIvY2V4')
            .update({url : image.data.url})
            .then(() => {
                cover.value = '';
                document.getElementById('successCover').innerHTML = 'Cover Updated!';
            });
        })
    }

    return (
        <div className="col-md-6">
            <article className="shadow py-4 px-3 p-md-5 h-100">
                <h4 className="title mb-4"><b>Update Cover</b></h4>
                <form className="px-2" onSubmit={updateCover}>
                    <input id="coverID" type="file" className="my-3" name="cover" required />
                    <input type="submit" value="Update Cover" className="text-white btn btn-one px-5" />
                </form>
                <p id="successCover" className="text-center my-3 text-success"></p>
            </article>            
        </div>
    );
};

export default UpdateCover;